








































import { Component, Prop, Vue } from "vue-property-decorator";
import { ReferralTriageDetailsModel } from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class ReferralToView extends Vue {
  @Prop()
  advancedMode!: boolean;

  @Prop({ default: null })
  referral!: ReferralTriageDetailsModel;
}
